import React from 'react';
import { Layout, Grid, Heading } from '@enterprise-ui/canvas-ui-react';

// eslint-disable-next-line no-unused-vars
var SectionHeader = function SectionHeader(_ref) {
  var pageHeading = _ref.pageHeading,
    pageActions = _ref.pageActions;
  return /*#__PURE__*/React.createElement(Layout.SectionHeader, null, /*#__PURE__*/React.createElement("div", {
    className: "hc-pa-dense hc-pb-none"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "normal",
    justify: "space-between"
  }, pageHeading && /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Heading, {
    "data-testid": "sectionHeaderHeading",
    size: 3
  }, pageHeading)), pageActions && /*#__PURE__*/React.createElement(Grid.Item, null, pageActions))));
};

export { SectionHeader as default };
